<template>
  <carousel
    :perPageCustom="[[300, 1], [767, 2], [1024, 5]]"
    :paginationEnabled=true
    :autoplay=false
    :scrollPerPage=false
    :autoplayTimeout=2000
    :autoplayHoverPause=true
    :loop=true
    :infiniteLoop=true

    :paginationPadding="2"
    paginationActiveColor="#000000"
    paginationColor="#dddddd"
  >
    <slide v-for="(content, index) in this.content" :key="index">
      <b-row class="justify-content-center">
        <b-col cols="10">
          <b-img
            :src="require('@/assets/icon/how-it-works/' + content.img)"
            fluid
          />
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col class="sg-reason-title">
          {{ content.title }}
        </b-col>
      </b-row>

      <b-row>
        <b-col class="sg-reason-subtitle">
          {{ content.subtitle }}
          <router-link :to="{ name: 'HowItWorks' }">Read More</router-link>
        </b-col>
      </b-row>
    </slide>
  </carousel>
</template>

<script>
export default {
  name: 'Carousel_HowItWorks',
  props: ['content']
}
</script>

<style scoped>
.sg-reason-title {
  font-size: 18px;
  font-weight: 600;
  text-align: center;
}
.sg-reason-subtitle {
  font-size: 16px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Carousel/HowItWorks/HowItWorks.vue